import { Bell, CarFront, ShieldCheck, UserRound, LayoutDashboard } from "lucide-react";
import { LANGS, getLang, setLang, t } from "@/lib/i18n";

const LangSelect = () => (
  <select data-testid="lang-select" aria-label={t("Lingua")} value={getLang()} onChange={(e) => setLang(e.target.value)}
    className="h-10 w-[54px] sm:w-auto rounded-lg bg-black border border-[#27272A] text-white text-sm font-semibold px-1 mr-1 cursor-pointer hover:border-[#10B981] focus:outline-none">
    {LANGS.map((l) => <option key={l.code} value={l.code} data-testid={`lang-option-${l.code}`}>{l.flag} {l.code.toUpperCase()}</option>)}
  </select>
);

const NAV = [
  { key: "myrides", label: "My Rides", icon: CarFront, testid: "nav-my-rides-button" },
  { key: "legal", label: "Legal & Security", icon: ShieldCheck, testid: "nav-legal-button" },
  { key: "profile", label: "Profilo", icon: UserRound, testid: "nav-profile-button" },
];

const Dot = ({ testid, className, children }) => (
  <span data-testid={testid} className={`absolute top-1.5 right-1.5 min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-extrabold flex items-center justify-center ${className}`}>{children}</span>
);

export const Header = ({ onOpen, verified, unread, user, online }) => (
  <header className="ff-header sticky top-0 z-50" data-testid="app-header">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-2">
      <a href="#top" data-testid="brand-logo" className="ff-brand-wrap relative z-0 flex flex-col min-w-0">
        <span className="ff-brand">FLEETFLOW</span>
        <span data-testid="network-status-indicator" className="flex items-center gap-2 mt-1.5 text-[9px] sm:text-[10px] font-semibold uppercase tracking-[0.1em] text-[#6EE7B7] whitespace-nowrap">
          <span className="ff-pulse-dot" />
          FLEETFLOW • B2B Network Online{online ? ` • ${online}` : ""}
        </span>
      </a>
      <nav className="flex items-center">
        <LangSelect />
        {user && <button type="button" data-testid="nav-notifications-button" aria-label="Notifiche Smart Match" className="ff-nav-btn !min-w-[44px] !px-2" onClick={() => onOpen("notifications")}>
          <Bell size={20} strokeWidth={2} />
          {unread > 0 && <Dot testid="nav-notifications-count" className="bg-[#10B981] text-white">{unread > 9 ? "9+" : unread}</Dot>}
        </button>}
        {user?.role === "admin" && (
          <button type="button" data-testid="nav-admin-button" aria-label="Admin" className="ff-nav-btn !min-w-[44px] !px-2" onClick={() => onOpen("admin")}>
            <LayoutDashboard size={20} className="text-amber-400" />
          </button>
        )}
        {NAV.filter((n) => user || n.key === "legal").map(({ key, label, icon: Icon, testid }) => (
          <button key={key} type="button" data-testid={testid} aria-label={label} className="ff-nav-btn !min-w-[44px] !px-2 md:!px-3" onClick={() => onOpen(key)}>
            <Icon size={20} strokeWidth={2} className={key === "legal" ? "text-[#3B82F6]" : ""} />
            <span className="hidden md:inline">{t(label)}</span>
          </button>
        ))}
        {user === false && (
          <button type="button" data-testid="nav-login-button" onClick={() => onOpen("auth")} className="ff-btn-primary !min-h-[44px] px-3 sm:px-4 text-sm ml-1 whitespace-nowrap">{t("ACCEDI")}</button>
        )}
      </nav>
    </div>
  </header>
);
